import { useState, useEffect } from "react";
import toastError from "../../errors/toastError";
import { getHelpCategories } from "../../services/helpApi";

const useHelpCategories = ({ searchParam, parentId }) => {
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [count, setCount] = useState(0);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchCategories = async () => {
        try {
          const { data } = await getHelpCategories({
            searchParam,
            parentId
          });

          setCategories(Array.isArray(data?.categories) ? data.categories : []);
          setCount(typeof data?.count === 'number' ? data.count : 0);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      };

      fetchCategories();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam, parentId]);

  return { categories, loading, count };
};

export default useHelpCategories;
